// Flots - French translations (JSON format for react-intl)
const fr: Record<string, string> = {
  // ----- Navigation -----
  "nav.features": "Fonctionnalités",
  "nav.centralization": "Gestion centralisée",
  "nav.suggestions": "Suggestions Automatiques",
  "nav.notifications": "Notifications Intelligentes",
  "nav.pricing": "Tarifs",
  "nav.team": "L'équipe",
  "nav.contact": "Contact",
  "nav.cta": "Ouvrir Flots",
  // Sign-up pill of the mobile app bar: kept short, it shares the bar with the brand and the menu.
  "nav.ctaShort": "Essai gratuit",

  // ----- Promo Banner -----
  "promo.banner.text": "2 mois offerts sur tous les plans, sans carte bancaire",
  "promo.banner.textShort": "2 mois offerts sur tous les plans",
  "promo.banner.cta": "J'en profite",

  // ----- Hero Section -----
  "hero.discount": "50% de réduction",
  "hero.discountUntil": "jusqu'au 15 Janvier",
  "hero.titleNeed": "Besoin d'un",
  "hero.titleSecretary": "Secrétaire",
  "hero.titlePocket": "de poche ?",
  "hero.description":
    "Découvrez un outil fait pour vous accompagner dans votre organisation, adaptable à votre quotidien et facile à prendre en main.",
  "hero.cta": "Essayer gratuitement 30 jours",
  "hero.noCreditCard": "pas de",
  "hero.ccRequired": "requise",
  "hero.users": "+100 utilisateurs nous ont déjà rejoint",
  "hero.available": "Disponible partout",
  "hero.titleOrganization": "Votre organisation",
  "hero.titleSimplified": "simplifiée",
  "hero.benefit1Title": "Rien à construire.",
  "hero.benefit1Desc": "Des outils que votre équipe connaît déjà. Cinq minutes, et vous travaillez.",
  "hero.benefit2Title": "De la réunion à l'action.",
  "hero.benefit2Desc":
    "Vos notes deviennent des t\u00e2ches\u202f: Cap propose, vous validez.",
  "hero.benefit3Title": "Vos données restent les vôtres.",
  "hero.benefit3Desc": "Hébergées en Europe. Chacun décide de ce qu'il partage.",
  "hero.ctaPrimary": "Testez Flots gratuitement",
  "hero.ctaSecondary": "Demandez une démo",
  "hero.freeBadge": "2 mois offerts",
  "hero.noCard": "sans carte bancaire",
  "hero.subhead":
    "Tâches, agenda, notes et projets dans un seul outil français, utilisable en cinq minutes, sans rien paramétrer.",
  "hero.availableOn": "Disponible sur",
  "hero.web": "Web",
  "hero.appStore": "App Store",
  "hero.googlePlay": "Google Play",
  "hero.devices": "sur votre ordinateur, votre smartphone et tablette",
  "hero.word1": "simplifiée",
  "hero.word2": "clarifiée",
  "hero.word3": "optimisée",
  "hero.word4": "maîtrisée",
  "hero.whoAreYou": "Qui êtes vous ?",
  "hero.individual": "Un individu",
  "hero.organization": "Une organisation",
  "hero.feature1Title": "Tout au même endroit, et tout de suite utilisable",
  "hero.feature1Desc":
    "Tâches, agenda, notes, projets. Votre planning et vos connaissances au même endroit, sans jongler entre cinq outils.",
  "hero.feature1Point1Title": "Tout au même endroit.",
  "hero.feature1Point1Desc":
    "Un client, un espace : ses notes, ses échéances, ses livrables.",
  "hero.feature1Point2Title": "Vous retrouvez en trois secondes.",
  "hero.feature1Point2Desc":
    "Une recherche, et l'information remonte, où qu'elle soit rangée.",
  "hero.feature1Point3Title": "Zéro double saisie.",
  "hero.feature1Point3Desc":
    "Ce qui est noté une fois se retrouve partout où c'est utile.",
  "hero.feature2Title": "Rien à construire, rien à apprendre",
  "hero.feature2Desc":
    "Créez une tâche ou une note en deux clics, et retrouvez-les sans effort. L'outil s'adapte à votre façon de travailler, pas l'inverse.",
  "hero.feature2Point1Title": "Vous êtes opérationnel en cinq minutes.",
  "hero.feature2Point1Desc": "Rien à paramétrer, rien à maintenir.",
  "hero.feature2Point2Title": "Deux clics, pas dix.",
  "hero.feature2Point2Desc":
    "Capturer une idée ne casse jamais votre élan.",
  "hero.feature2Point3Title": "Sur tous vos écrans.",
  "hero.feature2Point3Desc":
    "Mobile, tablette, navigateur : la même organisation partout.",
  "hero.feature3Title": "De la réunion à l'action, sans y penser",
  "hero.feature3Desc":
    "Vos notes de réunion deviennent des tâches, que vous validez ou corrigez. Cap propose, vous décidez.",
  "hero.feature3Point1Title": "Vous voyez venir ce qui compte.",
  "hero.feature3Point1Desc":
    "Ce qui est urgent remonte, le reste attend son tour.",
  "hero.feature3Point2Title": "Votre journée se prépare à l'heure que vous choisissez.",
  "hero.feature3Point2Desc": "L'assistant propose, vous ajustez.",
  "hero.feature3Point3Title": "Vous vous déchargez l'esprit.",
  "hero.feature3Point3Desc":
    "L'organisation ne devient pas votre second métier.",


  // ----- Application Section -----
  "app.title": "L'Application Flots",
  "app.needOrganization": "organisation solide",
  "app.busyLife": "quotidien chargé",
  "app.manyProjects": "nombreux projets en cours",
  "app.deadlines":
    "avec leurs propres échéances, impératifs et connaissances ?",
  "app.clarity": "clarté dans vos projets",
  "app.calendar": "calendrier",
  "app.tasks": "tâches",
  "app.notes": "notes",
  "app.samePlace": "au même endroit et profitez de nos",
  "app.ai": "IAs avancées",
  "app.aiSuffix": "pour vous seconder.",
  "app.easeOfUse": "facilité de prise en main réfléchie",
  "app.adapts": "s'adapte à vous",
  "app.enjoyEase": "Profitez d'une",
  "app.forOnce": "Pour une fois, c'est l'outil qui",
  "app.or": "ou",
  "app.tryYourself": "Testez par vous-même",
  "app.videoButton": "Laissez-nous vous présenter Flots",
  "app.needIntro": "Besoin d'une",
  "app.toFace": "pour faire face à un",
  "app.questionMark": "De",
  "app.flotsGives": "Flots vous apporte de la",
  "app.findYour": "Retrouvez votre",
  "app.your": "vos",
  "app.and": "et vos",

  // ----- How/Promise Section -----
  "how.title": "Notre Promesse",
  "how.promise1":
    "Nous voulons permettre aux indépendants et aux petites équipes de",
  "how.promise1Focus": "passer moins de temps sur l'organisation",
  "how.promise1End": "pour se",
  "how.promise1Essential": "focaliser sur l'essentiel",
  "how.promise1Suffix": "de leur métier : leurs projets et leurs clients.",
  "how.promise2": "Nous souhaitons avoir une",
  "how.promise2Human": "approche humaine",
  "how.promise2Middle":
    ", qui se base sur la compréhension quotidienne des besoins et des contraintes de nos utilisateurs pour développer des",
  "how.promise2Tech": "technologies adaptées",
  "how.tagline1": "Un outil",
  "how.taglinePresent": "présent",
  "how.tagline2": "dès qu'il le faut, capable d'",
  "how.taglineAnticipate": "anticiper",
  "how.tagline3": "votre charge de travail et de",
  "how.taglineBlend": "se fondre",
  "how.tagline4": "dans vos habitudes...",
  "how.cta": "Qui sommes-nous ?",

  // ----- Features Section -----
  "features.title": "Fonctionnalités",
  "features.centralizationTitle": "Gestion centralisée",
  "features.centralizationDesc":
    "Vous en avez marre de jongler entre vos notes, votre agenda, vos tâches pour rester à jour ? Avec Flots, accédez à tous vos outils au même endroit et depuis toutes les plateformes.",
  "features.suggestionsTitle": "Suggestions Automatiques",
  "features.suggestionsEta": "Sortie estimée Mars 2026",
  "features.suggestionsDesc":
    "Prenez vos notes sans vous prendre la tête, et laissez nous détecter les tâches que aurez décrites, les catégoriser automatiquement, ou les résumer pour un bref récapitulatif.",
  "features.notificationsTitle": "Notifications Intelligentes",
  "features.notificationsEta": "Sortie estimée Mai 2026",
  "features.notificationsDesc":
    "Ne perdez pas l'information importante. Ayez conscience de votre charge de travail et ne laissez plus les urgences se fondre dans les centaines de notification que nous recevons chaque jour.",

  // ----- Pricing Section -----
  "pricing.title": "Nos Tarifs",
  "pricing.trialTitle": "Plan d'Essai",
  "pricing.trialPrice": "Gratuit",
  "pricing.trialDuration": "pendant 30 jours",
  "pricing.trialFeature1":
    "Accès aux fonctionnalités classiques du plan individuel",
  "pricing.trialFeature2": "Testez l'application en conditions réelles",
  "pricing.trialCta": "Essayer",
  "pricing.individualDiscount": "-30% jusqu'à février",
  "pricing.individualYearlyDiscount": "-50% jusqu'à février",
  "pricing.individualTitle": "Plan Individuel",
  "pricing.perMonth": "(HT) / mois",
  "pricing.perYear": "(HT) / an",
  "pricing.noCommitment": "sans engagement durant 12 mois",
  "pricing.individualFeature1": "Accès sans limitations à l'application",
  "pricing.individualFeature2": "Suggestions automatiques (bientôt disponible)",
  "pricing.individualFeature3": "Notifications intelligentes",
  "pricing.individualFeature4": "Support client avancé",
  "pricing.individualCta": "En Profiter",
  "pricing.teamTitle": "Plan Annuel",
  "pricing.teamEta": "-50% de réduction !",
  "pricing.teamUsers5": "Jusqu'à 5 utilisateurs",
  "pricing.teamUsers10": "Jusqu'à 10 utilisateurs",
  "pricing.interested": "intéressé ?",
  "pricing.teamCta": "Nous contacter",
  "pricing.modalTitle": "Merci de votre intérêt !",
  "pricing.modalDesc":
    "Nous finissons les derniers préparatifs pour aller avec la nouvelle version. Elle sera prête mi-Novembre 2025. Suivez nous sur Linkedin pour être au courant du jour de sa sortie !",
  "pricing.modalLinkedin": "Notre Linkedin",
  "pricing.modalPrototype": "Prototype gratuit déjà disponible partout !",

  // ----- Comparison Section -----
  "compare.badge": "Comparatif",
  "compare.switch.label": "Comparer pour",
  "compare.switch.team": "Équipe",
  "compare.switch.individual": "Individuel",
  "compare.criteriaHeader": "Critère",
  "compare.support.yes": "Oui",
  "compare.support.partial": "Partiellement",
  "compare.support.no": "Non",
  "compare.price.unavailable": "Prix indisponible",
  "compare.team.title": "Une alternative française et simple à Notion, Trello ou Todoist pour votre équipe",
  "compare.team.subtitle":
    "Les grosses plateformes réclament un poste dédié. Les petits outils, c'est vous qui les reliez. Flots Team démarre le jour même, sans rien paramétrer.",
  "compare.team.caption":
    "Comparaison du plan Flots Team avec Notion Business, Trello Premium et Todoist Business sur cinq critères et le prix par utilisateur",
  "compare.team.plan.flots": "Team",
  "compare.team.plan.notion": "Business",
  "compare.team.plan.trello": "Premium",
  "compare.team.plan.todoist": "Business",
  "compare.team.row.centralization": "Mon équipe retrouve ses tâches, son agenda et ses notes au même endroit",
  "compare.team.row.notesToTasks": "Les comptes rendus de réunion deviennent des tâches, sans les recopier",
  "compare.team.row.noSetup": "Mon équipe démarre le jour même, sans rien paramétrer",
  "compare.team.row.frenchSupport": "Mon équipe est aidée en français, par une équipe joignable",
  "compare.team.row.euHosting": "Les données de mon entreprise sont chez des européens",
  "compare.team.row.price": "Ce que je paie par utilisateur et par mois, plan entreprise",
  "compare.team.price.notion": "20 $",
  "compare.team.price.trello": "12,50 $",
  "compare.team.price.todoist": "10 $",
  "compare.team.footnote":
    "Plans entreprise facturés au mois, par utilisateur : Notion Business, Trello Premium et Todoist Business, prix publics en dollars relevés en octobre 2026 sur leurs pages tarifs, avant remises annuelles. Flots Team : prix hors taxes du catalogue Flots, en euros.",
  "compare.individual.title": "Une alternative française et simple à Notion, Trello ou Todoist",
  "compare.individual.subtitle":
    "Les grosses plateformes réclament un poste dédié. Les petits outils, c'est vous qui les reliez. Flots démarre en 5 minutes, sans rien paramétrer.",
  "compare.individual.caption":
    "Comparaison du plan Flots Individuel avec Notion Plus, Trello Standard et Todoist Pro sur cinq critères et le prix mensuel",
  "compare.individual.plan.flots": "Individuel",
  "compare.individual.plan.notion": "Plus",
  "compare.individual.plan.trello": "Standard",
  "compare.individual.plan.todoist": "Pro",
  "compare.individual.row.centralization": "Je retrouve mes tâches, mon agenda et mes notes au même endroit",
  "compare.individual.row.notesToTasks": "Mes notes se transforment en tâches sans effort",
  "compare.individual.row.noSetup": "Je démarre sans rien paramétrer",
  "compare.individual.row.frenchSupport": "Je suis aidé en français, par une équipe joignable",
  "compare.individual.row.euHosting": "Mes données sont chez des européens",
  "compare.individual.row.price": "Ce que je paie par mois, plan individuel",
  "compare.individual.price.notion": "10 $",
  "compare.individual.price.trello": "6 $",
  "compare.individual.price.todoist": "7 $",
  "compare.individual.footnote":
    "Plans individuels facturés au mois : Notion Plus, Trello Standard et Todoist Pro, prix publics en dollars relevés en octobre 2026 sur leurs pages tarifs, avant remises annuelles. Flots Individuel : prix hors taxes du catalogue Flots, en euros.",

  // ----- Pricing Section v3 -----
  "pricing3.eyebrow": "Tarifs",
  "pricing3.title": "Des tarifs simples, sans engagement",
  "pricing3.subtitle":
    "2 mois offerts sur tous les plans, sans carte bancaire. Vous arrêtez quand vous voulez.",
  "pricing3.billingCycle": "Cycle de facturation",
  "pricing3.monthly": "Mensuel",
  "pricing3.annual": "Annuel",
  "pricing3.annualWithDiscount": "Annuel −{percent} %",
  "pricing3.priceMode": "Affichage des prix",
  "pricing3.priceMode.ht": "HT",
  "pricing3.priceMode.ttc": "TTC",
  "pricing3.priceUnavailable": "Prix indisponible",
  "pricing3.trial": "2 mois d'essai gratuit",
  "pricing3.billedAnnually": "facturé annuellement, 2 mois d'essai gratuit",
  "pricing3.annualTotal": "soit {total} à l'année",
  // Phones and tablets: a plan card's feature list opens on its first lines.
  "pricing3.featuresMore": "{count, plural, one {Voir l'autre avantage} other {Voir les # autres avantages}}",
  "pricing3.featuresLess": "Voir moins",

  "pricing3.indiv.badge": "2 mois offerts",
  "pricing3.indiv.title": "Individuel",
  "pricing3.indiv.desc":
    "Pour ceux qui travaillent seuls, avec quelques projets à gérer.",
  "pricing3.indiv.unit": "/ mois",
  "pricing3.indiv.f1": "Tâches, Agenda illimités",
  "pricing3.indiv.f2": "512 Mo de stockage (docs, notes…)",
  "pricing3.indiv.f3": "3 projets partagés, jusqu'à 3 collaborateurs",
  "pricing3.indiv.f4": "Espace de travail personnel",
  "pricing3.indiv.f5": "Accès MCP",
  "pricing3.indiv.f6": "Accès Cap : 300 crédits",
  "pricing3.indiv.f7": "Import automatique (Notion, Todoist)",

  "pricing3.pro.badge": "Le plus populaire",
  "pricing3.pro.title": "Pro",
  "pricing3.pro.desc":
    "Pour ceux qui travaillent seuls ou en groupe, avec des besoins plus poussés.",
  "pricing3.pro.unit": "/ mois",
  "pricing3.pro.f1": "Tâches, Agenda illimités",
  "pricing3.pro.f2": "10 Go de stockage (docs, notes…)",
  "pricing3.pro.f3": "Projets illimités",
  "pricing3.pro.f4": "Espace de travail personnel + 1 organisation",
  "pricing3.pro.f5": "Accès MCP",
  "pricing3.pro.f6": "Accès Cap : 750 crédits",
  "pricing3.pro.f7": "Import automatique (Notion, Todoist)",
  "pricing3.pro.f8": "Toutes les intégrations (Drive, GitHub)",

  "pricing3.team.badge": "Gestion d'équipe",
  "pricing3.team.title": "Team",
  "pricing3.team.desc":
    "Pour les équipes qui ont besoin de travailler efficacement à plusieurs.",
  "pricing3.team.unit": "/ utilisateur / mois",
  "pricing3.team.f1": "Tâches, Agenda illimités",
  "pricing3.team.f2": "100 Go de stockage (docs, notes…)",
  "pricing3.team.f3": "Projets illimités",
  "pricing3.team.f4": "10 Organisations",
  "pricing3.team.f5": "Accès MCP",
  "pricing3.team.f6": "Accès Cap : 1500 crédits",
  "pricing3.team.f7": "Import automatique (Notion, Todoist)",
  "pricing3.team.f8": "Toutes les intégrations (Drive, GitHub)",
  "pricing3.team.f9": "Facturation unique pour toute l'équipe",
  "pricing3.team.f10": "Coffre-fort pour les secrets (bientôt)",

  "pricing3.cta.trial": "Essayer gratuitement",
  "pricing3.cta.demo": "Réserver une démo",
  "pricing3.reassurance.payment":
    "Vous réglez par carte bancaire, en toute sécurité",
  "pricing3.reassurance.manage":
    "Vous gérez abonnement et préférences dans votre espace client",
  "pricing3.reassurance.cancel": "Vous résiliez en 1 clic, sans engagement",

  // ----- FAQ Section -----
  "faq.eyebrow": "FAQ",
  "faq.title": "Questions fréquentes",
  "faq.subtitle":
    "Tout ce que vous vous demandez avant de vous lancer. Une question qui n'est pas là ? Nous répondons sous 24 h.",

  "faq.free.q": "Est-ce vraiment gratuit ?",
  "faq.free.a":
    "Oui. Vous testez le plan de votre choix gratuitement pendant 2 mois, sans carte bancaire. Ensuite, sans engagement : vous arrêtez en un clic.",

  "faq.devices.q": "Sur quels appareils puis-je m'organiser ?",
  "faq.devices.a":
    "Web, iOS, Android, tablette et iPad. Vos tâches, votre agenda et vos notes se synchronisent partout.",

  "faq.onboarding.q": "Combien de temps avant d'être opérationnel ?",
  "faq.onboarding.a":
    "Cinq minutes. Rien à paramétrer, rien à maintenir : vous commencez à noter et à organiser dès l'inscription. Vous pouvez importer automatiquement les données depuis votre application préférée (Notion, Todoist) pour commencer tout de suite avec vos propres données.",

  "faq.import.q": "Puis-je récupérer mes données de Notion, Trello ou Todoist ?",
  "faq.import.a":
    "Oui, pour Notion et Todoist dès aujourd'hui. L'import depuis Trello est en préparation.",

  "faq.billing.q": "Comment je gère mon abonnement et mes préférences ?",
  "faq.billing.a":
    "Tout se passe dans votre espace client : changer de plan, mettre à jour votre carte, ou résilier en un clic, sans nous contacter.",

  "faq.team.q": "Puis-je l'utiliser avec mon équipe ?",
  "faq.team.a":
    "Oui. Le plan Pro permet de partager des projets sans limite. Le plan Team ajoute la gestion multi-organisations, la facturation centralisée et le suivi de charge d'équipe.",

  "faq.data.q": "Où sont mes données ?",
  "faq.data.a":
    "Hébergées en Europe, en France à terme. Tous nos fournisseurs respectent RGPD. Elles ne sont jamais revendues à des tiers.",

  "faq.more.title": "Il vous manque une réponse ?",
  "faq.more.desc":
    "Racontez-nous votre organisation et ce qui vous bloque. Nous répondons sous 24 h.",
  "faq.more.contact": "Nous écrire",
  "faq.more.demo": "Réserver une démo",

  // ----- Final CTA -----
  "finalCta.title": "Demain matin, vous saurez par quoi commencer",
  "finalCta.subtitle":
    "Créez votre compte en 30 secondes. 2 mois offerts, sans carte bancaire.",
  "finalCta.signup": "Créer mon compte gratuit",
  "finalCta.demo": "Réserver une démo",

  // ----- Contact Section -----
  "contact.title": "Une Question ? Contactez-Nous.",
  "contact.subtitle": "Nous répondons sous 24h.",
  "contact.intro.title": "Parlons de votre organisation et de vos problématiques",
  "contact.intro.desc":
    "Une question, une idée ou envie de voir Flots en action ? Écrivez-nous, nous répondrons rapidement.",
  "contact.demo.title": "Demander une démo",
  "contact.demo.desc":
    "Vous préférez un échange en direct ? Réservez un créneau avec notre équipe.",
  "contact.demo.cta": "Réserver un créneau",
  "contact.success": "Message envoyé ! Nous vous répondrons sous 24h.",
  "contact.sendAnother": "Envoyer un autre message",
  "contact.formTitle": "Formulaire",
  "contact.formDesc":
    "Utilisez ce formulaire pour nous contacter. Nous vous répondrons dès que possible. N'hésitez pas à nous donner le plus de détails possible pour avoir une réponse pertinente plus rapidement.",
  "contact.name": "Nom",
  "contact.email": "Email",
  "contact.subject": "SUJET",
  "contact.content": "CONTENU",
  "contact.placeholder": "Décrivez votre demande",
  "contact.submit": "Envoyer",
  "contact.sending": "Envoi...",
  "contact.selectSubject": "Sélectionner un sujet",
  "contact.subjectSubscriptions": "Abonnements",
  "contact.subjectBug": "Bug",
  "contact.subjectFeedback": "Retour d'utilisation",
  "contact.subjectCollaboration": "Collaboration",
  "contact.subjectFeatureIdea": "Idée de fonctionnalités",
  "contact.subjectOther": "Autre",

  // ----- Use Case Section -----
  "usecase.title": "Cas d'usage",
  "usecase.intro":
    "On vous propose de regarder ces exemples de cas d'usage ci-dessous pour avoir une idée concrète de l'utilisation de Flots dans votre quotidien.",
  "usecase.question": "Vous êtes ?",
  "usecase.independent": "Indépendant",
  "usecase.smallBusiness": "Petite Entreprise",
  "usecase.indepTitle": "Cas de Sylvie, Designer Graphique Indépendante",
  "usecase.indepIntro":
    "Sylvie est spécialisée dans le design graphique. Elle crée des logos, des chartes graphiques et parfois des designs de sites web. Elle travaille surtout avec de petites enseignes de restauration, qu'elle affectionne pour leur proximité et leur authenticité.",
  "usecase.indepPara1":
    "Au début de chaque projet, elle se rend sur place pour un premier rendez-vous client, carnet en main, prête à noter chaque détail : les couleurs du lieu, les valeurs du restaurateur, l'ambiance recherchée. Mais rapidement, les pages s'accumulent, les projets se croisent, et les idées se perdent dans la masse.",
  "usecase.indepPara2":
    "Chaque mission implique ses propres échéances, ses inspirations, ses fichiers à livrer, ses échanges avec les imprimeurs ou les développeurs. Sylvie se retrouve souvent à chercher où elle a noté telle info, ou quand elle doit livrer tel visuel. Son carnet ne suffit plus.",
  "usecase.indepPara3": "C'est à ce moment-là qu'un ami lui parle de Flots",
  "usecase.indepPara3Suffix":
    ". Lui aussi travaille en indépendant, et il lui explique comment l'application l'aide à garder le contrôle sur ses projets sans se noyer dans les outils. Intriguée, Sylvie décide d'essayer.",
  "usecase.indepPara4":
    "Avec Flots, Sylvie centralise tout : ses projets, ses notes, ses rendez-vous, ses livrables. Chaque commande devient un espace clair, vivant, où elle retrouve ses tâches, ses idées et ses deadlines. L'application lui permet d'avoir à la fois une vision globale de sa charge de travail, et une vue locale centrée sur chaque client.",
  "usecase.indepPara5":
    "Quand un nouveau projet commence, elle le crée dans l'application. Elle y glisse les dates clés, ses notes de repérage, les maquettes à valider, et même les rappels automatiques pour ses suivis clients. Plus besoin de jongler entre plusieurs outils :",
  "usecase.indepPara5Bold": "Flots s'adapte à sa façon de travailler",
  "usecase.pmeTitle": "Cas d'une petite entreprise",
  "usecase.pmeIntro":
    "Une petite équipe d'une dizaine de personnes réunit des profils techniques et commerciaux. Leur quotidien est rythmé par les rendez-vous clients, les points internes et le suivi de multiples projets en parallèle.",
  "usecase.pmePara1":
    "Chacun prend des notes à sa manière : certains dans leur téléphone, d'autres sur leur ordinateur, d'autres encore dans un carnet.",
  "usecase.pmePara2":
    "Petit à petit, l'information se disperse et les rappels s'accumulent. Les échanges se font par messages, souvent non lus, et les tâches urgentes passent parfois inaperçues.",
  "usecase.pmePara3":
    "Ils ont tenté d'utiliser Notion pour centraliser leur travail, mais l'outil s'est révélé trop complexe pour leurs besoins. Créer et maintenir les pages leur demandait plus de temps qu'ils n'en gagnaient.",
  "usecase.pmePara4":
    "L'équipe est revenue à des outils plus simples, mais sans réelle coordination : aucune vue d'ensemble, aucun lien entre les notes, les tâches et les calendriers.",
  "usecase.pmePara5":
    "Le besoin s'est alors précisé : disposer d'un espace partagé, clair et rapide à utiliser, capable de relier leurs échanges, leurs actions et leurs échéances.",
  "usecase.pmePara6":
    "Avec Flots, ils trouvent un équilibre entre structure et simplicité. Après un rendez-vous, un membre de l'équipe saisit ses notes directement dans l'application.",
  "usecase.pmePara7":
    "Les actions à mener sont automatiquement détectées et transformées en tâches. Celles-ci apparaissent dans le calendrier de l'équipe, connecté à Google Agenda, et peuvent être assignées ou réorganisées selon les priorités.",
  "usecase.pmePara8":
    "La vue chronologique ou Gantt donne une vision immédiate de l'avancement, sans nécessiter de paramétrage complexe.",
  "usecase.pmePara9":
    "L'équipe ne passe plus son temps à synchroniser les outils ou à recopier les informations. Chacun voit ce qu'il doit faire, quand, et avec qui. Les discussions reprennent leur place dans le travail plutôt que dans les rappels.",
  "usecase.pmePara10":
    "L'information circule mieux, les suivis deviennent plus fiables, et la charge mentale collective diminue",

  // ----- Team page (a story in four chapters; lorem ipsum until the copy is written) -----
  "team.hero.title": "Lorem ipsum dolor sit amet consectetur",
  "team.hero.lead": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  "team.hero.cta": "Lire notre histoire",
  "team.chapter.of": "Chapitre {n} sur {total} : ",
  "team.chapter.who.label": "Qui on est",
  "team.chapter.who.title": "Lorem ipsum dolor sit amet",
  "team.chapter.who.lead": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  "team.chapter.why.label": "Pourquoi nous",
  "team.chapter.why.title": "Lorem ipsum dolor sit amet",
  "team.chapter.why.lead": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  "team.chapter.origin.label": "D'où on vient",
  "team.chapter.origin.title": "Lorem ipsum dolor sit amet",
  "team.chapter.origin.lead": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  "team.chapter.next.label": "Où on va",
  "team.chapter.next.title": "Lorem ipsum dolor sit amet",
  "team.chapter.next.lead": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  "team.founder.photoAlt": "Portrait de {name}",
  "team.founder.killian.role": "Lorem ipsum dolor",
  "team.founder.killian.bio": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.founder.killian.tag1": "Lorem ipsum",
  "team.founder.killian.tag2": "Dolor sit",
  "team.founder.killian.tag3": "Amet",
  "team.founder.sylvain.role": "Lorem ipsum dolor",
  "team.founder.sylvain.bio": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.founder.sylvain.tag1": "Lorem ipsum",
  "team.founder.sylvain.tag2": "Dolor sit",
  "team.founder.sylvain.tag3": "Amet",
  "team.founder.erwan.role": "Lorem ipsum dolor",
  "team.founder.erwan.bio": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.founder.erwan.tag1": "Lorem ipsum",
  "team.founder.erwan.tag2": "Dolor sit",
  "team.founder.erwan.tag3": "Amet",
  "team.stat.s1": "Lorem ipsum dolor sit amet",
  "team.stat.s2": "Lorem ipsum dolor sit amet",
  "team.stat.s3": "Lorem ipsum dolor sit amet",
  "team.stat.s4": "Lorem ipsum dolor sit amet",
  "team.reason.r1.title": "Lorem ipsum dolor",
  "team.reason.r1.desc": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.reason.r2.title": "Lorem ipsum dolor",
  "team.reason.r2.desc": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.reason.r3.title": "Lorem ipsum dolor",
  "team.reason.r3.desc": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.milestone.m1.date": "Octobre 2024",
  "team.milestone.m1.title": "Lorem ipsum dolor sit amet",
  "team.milestone.m1.text": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.milestone.m2.date": "Hiver 2024",
  "team.milestone.m2.title": "Lorem ipsum dolor sit amet",
  "team.milestone.m2.text": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.milestone.m3.date": "Février 2025",
  "team.milestone.m3.title": "Lorem ipsum dolor sit amet",
  "team.milestone.m3.text": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.milestone.m4.date": "Avril 2025",
  "team.milestone.m4.title": "Lorem ipsum dolor sit amet",
  "team.milestone.m4.text": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.milestone.m5.date": "2026",
  "team.milestone.m5.title": "Lorem ipsum dolor sit amet",
  "team.milestone.m5.text": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.milestone.m1.alt": "Erwan et Sylvain à Paris, le prototype en main",
  "team.milestone.m2.alt": "Le premier prototype de Flots",
  "team.milestone.m5.alt": "Le poste de travail de l'équipe à l'InnovLab",
  "team.milestone.now": "Aujourd'hui",
  "team.next.manifesto": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  "team.horizon.h1.when": "Lorem ipsum",
  "team.horizon.h1.title": "Lorem ipsum dolor sit",
  "team.horizon.h1.desc": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.horizon.h2.when": "Lorem ipsum",
  "team.horizon.h2.title": "Lorem ipsum dolor sit",
  "team.horizon.h2.desc": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.horizon.h3.when": "Lorem ipsum",
  "team.horizon.h3.title": "Lorem ipsum dolor sit",
  "team.horizon.h3.desc": "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore.",
  "team.outro.title": "Lorem ipsum dolor sit amet",
  "team.outro.lead": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  "team.outro.try": "Essayer Flots",
  "team.outro.contact": "Nous écrire",

  // ----- Fund Section -----
  "fund.title": "Nous soutenir !",
  "fund.students": "nous sommes tous les 4 étudiants",
  "fund.description1": "Comme vous avez dû le comprendre,",
  "fund.description1End":
    "et comme vous devez le savoir, il ne s'agit pas de la catégorie socio-professionnelle ayant les revenus les plus abondants et stables.",
  "fund.description2":
    "Si le cœur vous en dit, vous pouvez nous aider financièrement pour nous aider à supporter les coûts de développement et de déploiement. Pour les prochains mois, nous laissons l'application libre d'accès donc nous n'aurons aucun revenus directs.",
  "fund.goal":
    "Nous souhaitons attendre d'atteindre une qualité satisfaisante avant de monétiser l'application",
  "fund.closing":
    "Voilà, vous avez le lien de la cagnotte juste en dessous que nous réinvestirons entièrement dans le projet :) (ne cassez pas vos tirelires non-plus)",
  "fund.thanks": "Merci beaucoup !!",
  "fund.cta": "Nous Soutenir",

  // ----- Footer -----
  "theme.label": "Thème",
  "theme.system": "Automatique (appareil)",
  "theme.light": "Clair",
  "theme.dark": "Sombre",
  "footer.copyright": "© 2026, Sinyx Studio · Flots, Tous droits réservés",
  "footer.presentation": "Présentation",
  "footer.application": "L'application",
  "footer.features": "Nos Fonctionnalités",
  "footer.pricing": "Nos Tarifs",
  "footer.team": "Notre Équipe",
  "footer.refund": "Politique de remboursement",
  "footer.privacy": "Politique de confidentialité",
  "footer.terms": "Conditions d'utilisation",
  "footer.privacyFr": "Politique de confidentialité (FR)",
  "footer.privacyEn": "Privacy Policy (EN)",
  "footer.contactUs": "Nous contacter",

  // ----- 404 Page -----
  "notFound.error": "ERREUR",
  "notFound.message":
    "La page n'a pas été trouvée. Veuillez vérifier l'URL ou retourner à la page d'accueil.",
  "notFound.home": "Accueil",

  // ----- Language Switcher -----
  "language.switch": "EN",

  // ----- Accessibility -----
  "a11y.brandHome": "Flots, accueil",
  "a11y.menuOpen": "Ouvrir le menu",
  "a11y.promoClose": "Fermer la bannière promotionnelle",
  "a11y.menuClose": "Fermer le menu",
  "a11y.navigationMenu": "Menu de navigation",
  "a11y.ressourcesCategories": "Voir les catégories de ressources",
  "a11y.languageSwitch": "EN, passer en anglais",
  "a11y.downloadGooglePlay": "Télécharger Flots sur Google Play",
  "a11y.downloadAppStore": "Télécharger Flots sur l'App Store",
  "a11y.openWebApp": "Ouvrir Flots Web App",
  "a11y.cap": "Cap, l'assistant Flots",
  "a11y.carousel.previous": "Précédent",
  "a11y.carousel.next": "Suivant",
  "a11y.carousel.slide": "Diapositive {number}",
  "a11y.video.resume": "Reprendre la lecture",
  "a11y.video.pause": "Mettre en pause",
  "a11y.video.enterFullscreen": "Passer en plein écran",
  "a11y.video.exitFullscreen": "Quitter le plein écran",
  "a11y.video.volume": "Volume",
  "a11y.video.unmute": "Activer le son",
  "a11y.video.mute": "Couper le son",
  "a11y.close": "Fermer",
  "a11y.features.titleImage": "Illustration des fonctionnalités de Flots",
  "a11y.features.centralizationImage": "Illustration de la gestion centralisée",
  "a11y.features.suggestionsImage": "Illustration des suggestions automatiques",
  "a11y.features.notificationsImage": "Illustration des notifications intelligentes",
  "a11y.application.organizationImage": "Illustration d'une organisation avec Flots",
  "a11y.application.managementImage": "Illustration de la gestion centralisée avec Flots",
  "a11y.profile.organizationImage": "Illustration de la gestion d'équipe avec Flots",
  "a11y.profile.collaborationImage": "Illustration de la collaboration en équipe sur Flots",
  "a11y.profile.delegationImage": "Illustration de la délégation et du suivi des tâches dans Flots",
  "a11y.profile.interfaceImage": "Illustration de l'interface intuitive de Flots",
  "a11y.profile.productivityImage": "Illustration d'un collaborateur productif avec Flots",
  "a11y.profile.onboardingImage": "Illustration de la prise en main de Flots en 5 minutes",
  "a11y.profile.longTermImage": "Illustration d'une organisation efficace sur la durée",
  "a11y.profile.featureIcon": "Icône Flots pour {feature}",
  // ----- Additional Component Keys -----
  "pricing.teamArrival": "Arrivée mi-février",
  "pricing.teamInterested": "intéressé ?",
  "pricing.teamContact": "Nous contacter",

  "contact.formDescription":
    "Utilisez ce formulaire pour nous contacter. Nous vous répondrons dès que possible. N'hésitez pas à nous donner le plus de détails possible pour avoir une réponse pertinente plus rapidement.",
  "contact.namePlaceholder": "Nom",
  "contact.emailPlaceholder": "Email",
  "contact.subjectLabel": "SUJET",
  "contact.subjectSelect": "Sélectionner un sujet",
  "contact.contentLabel": "CONTENU",
  "contact.contentPlaceholder": "Décrivez votre demande",
  "contact.send": "ENVOYER",

  "usecase.subtitle":
    "On vous propose de regarder ces exemples de cas d'usage ci-dessous pour avoir une idée concrète de l'utilisation de Flots dans votre quotidien.",
  "usecase.buttonIndep": "Indépendant",
  "usecase.buttonPME": "Petite Entreprise",
  "usecase.indepParagraph1":
    "Au début de chaque projet, elle se rend sur place pour un premier rendez-vous client, carnet en main, prête à noter chaque détail : les couleurs du lieu, les valeurs du restaurateur, l'ambiance recherchée. Mais rapidement, les pages s'accumulent, les projets se croisent, et les idées se perdent dans la masse.",
  "usecase.indepParagraph2":
    "Chaque mission implique ses propres échéances, ses inspirations, ses fichiers à livrer, ses échanges avec les imprimeurs ou les développeurs. Sylvie se retrouve souvent à chercher où elle a noté telle info, ou quand elle doit livrer tel visuel. Son carnet ne suffit plus.",
  "usecase.indepParagraph3":
    "<b>C'est à ce moment-là qu'un ami lui parle de Flots</b>. Lui aussi travaille en indépendant, et il lui explique comment l'application l'aide à garder le contrôle sur ses projets sans se noyer dans les outils. Intriguée, Sylvie décide d'essayer.",
  "usecase.indepParagraph4":
    "Quand un nouveau projet commence, elle le crée dans l’application. Elle y glisse les dates clés, ses notes de repérage, les maquettes à valider, et même les rappels automatiques pour ses suivis clients. Plus besoin de jongler entre plusieurs outils : <b>Flots s’adapte à sa façon de travailler.</b>",
  "usecase.indepParagraph5":
    "Avec Flots, Sylvie centralise tout : ses projets, ses notes, ses rendez-vous, ses livrables. Chaque commande devient un espace clair, vivant, où elle retrouve ses tâches, ses idées et ses deadlines. L’application lui permet d’avoir à la fois une vision globale de sa charge de travail, et une vue locale centrée sur chaque client.",
  "usecase.pmeParagraph1a":
    "Chacun prend des notes à sa manière : certains dans leur téléphone, d'autres sur leur ordinateur, d'autres encore dans un carnet.",
  "usecase.pmeParagraph1b":
    "Petit à petit, l'information se disperse et les rappels s'accumulent. Les échanges se font par messages, souvent non lus, et les tâches urgentes passent parfois inaperçues.",
  "usecase.pmeParagraph2a":
    "Ils ont tenté d'utiliser Notion pour centraliser leur travail, mais l'outil s'est révélé trop complexe pour leurs besoins. Créer et maintenir les pages leur demandait plus de temps qu'ils n'en gagnaient.",
  "usecase.pmeParagraph2b":
    "L'équipe est revenue à des outils plus simples, mais sans réelle coordination : aucune vue d'ensemble, aucun lien entre les notes, les tâches et les calendriers.",
  "usecase.pmeParagraph3a":
    "Le besoin s'est alors précisé : disposer d'un espace partagé, clair et rapide à utiliser, capable de relier leurs échanges, leurs actions et leurs échéances.",
  "usecase.pmeParagraph3b":
    "Avec Flots, ils trouvent un équilibre entre structure et simplicité. Après un rendez-vous, un membre de l'équipe saisit ses notes directement dans l'application.",
  "usecase.pmeParagraph4a":
    "Les actions à mener sont automatiquement détectées et transformées en tâches. Celles-ci apparaissent dans le calendrier de l'équipe, connecté à Google Agenda, et peuvent être assignées ou réorganisées selon les priorités.",
  "usecase.pmeParagraph4b":
    "La vue chronologique ou Gantt donne une vision immédiate de l'avancement, sans nécessiter de paramétrage complexe.",
  "usecase.pmeParagraph5a":
    "L'équipe ne passe plus son temps à synchroniser les outils ou à recopier les informations. Chacun voit ce qu'il doit faire, quand, et avec qui. Les discussions reprennent leur place dans le travail plutôt que dans les rappels.",
  "usecase.pmeParagraph5b":
    "L'information circule mieux, les suivis deviennent plus fiables, et la charge mentale collective diminue",

  // ----- Use Case Section - Individual content -----
  "usecase.indiv.banner.label": "Flots pour les individus",
  "usecase.indiv.banner.title": "Ce que nous vous offrons.",
  "usecase.indiv.s1.title": "Un système qui s'adapte.",
  "usecase.indiv.s1.c1.title": "Basé sur vos problématiques.",
  "usecase.indiv.s1.c1.desc":
    "Vous faites simple, l'application fait simple. Si vous voulez du détail, l'application le permet aussi.",
  "usecase.indiv.s1.tag1": "Procrastination",
  "usecase.indiv.s1.tag2": "Mal à focaliser",
  "usecase.indiv.s1.tag3": "Multi-tâches",
  "usecase.indiv.s1.tag4": "Débordé",
  "usecase.indiv.s1.c2.title": "Prévoyez les charges de travail",
  "usecase.indiv.s1.c2.desc":
    "Planifiez vos journées en quelques clics selon vos horaires.",
  "usecase.indiv.s1.c3.title": "Ton de Cap",
  "usecase.indiv.s1.c3.desc":
    "Amical, pragmatique... choisissez les qualités d'un assistant qui correspond à vos besoins.",
  "usecase.indiv.s2.title": "Des outils simples à prendre en main.",
  "usecase.indiv.s2.c1.title": "5 minutes top' chrono !",
  "usecase.indiv.s2.c1.desc":
    "C'est le temps qu'il vous faut pour créer votre compte, brancher votre agenda et commencer à travailler.",
  "usecase.indiv.s2.c2.title": "Une interface claire et accessible",
  "usecase.indiv.s2.c2.desc":
    "Nous vous fournissons une ergonomie qui vous permet de voir ce qui importe vraiment.",
  "usecase.indiv.s2.tools.label": "Des fonctionnalités que vous maîtrisez déjà.",
  "usecase.indiv.s2.tool1.title": "Gestion des tâches",
  "usecase.indiv.s2.tool1.desc": "Indiquez ce qu'il y a à faire, puis faites-le",
  "usecase.indiv.s2.tool2.title": "Agenda intégré",
  "usecase.indiv.s2.tool2.desc": "Votre emploi du temps en un coup d'œil",
  "usecase.indiv.s2.tool3.title": "Écrire des notes",
  "usecase.indiv.s2.tool3.desc": "Capturez vos idées à la volée",
  "usecase.indiv.s2.tool4.title": "Diriger vos projets",
  "usecase.indiv.s2.tool4.desc": "Pilotez et suivez vos avancées",
  "usecase.indiv.s3.title": "Une organisation pensée pour le long terme.",
  "usecase.indiv.s3.c1.title": "Suivez où vous en êtes sur vos projets",
  "usecase.indiv.s3.c1.desc":
    "Voyez en un coup d'œil les avancées, les étapes suivantes, les points bloquants...",
  "usecase.indiv.s3.c2.title": "Catégorisez proprement",
  "usecase.indiv.s3.c2.desc":
    "Segmentez comme vous en avez besoin vos sujets du quotidien.",
  "usecase.indiv.s3.c3.title": "Une force sur la durée",
  "usecase.indiv.s3.c3.desc":
    "Construisez une organisation durable qui évolue avec vous.",
  "usecase.indiv.s3.tag1": "Perso",
  "usecase.indiv.s3.tag2": "Travail",
  "usecase.indiv.s3.tag3": "Santé",
  "usecase.indiv.s3.tag4": "Loisirs",

  // ----- Use Case Section - Organisation content -----
  "usecase.org.banner.label": "Flots pour les organisations",
  "usecase.org.banner.title": "Ce que nous vous offrons.",
  "usecase.org.s1.title": "L'organisation à plusieurs, simplifiée.",
  "usecase.org.s1.c1.title": "Gérez vos projets ensemble.",
  "usecase.org.s1.c1.desc":
    "Travaillez dans des espaces communs, pensés pour une gestion rapide. Obtenez les informations dont vous avez besoin tout en ajoutant intelligemment les nouvelles.",
  "usecase.org.s1.c2.title": "Vos informations centralisées.",
  "usecase.org.s1.c2.desc":
    "Fini le temps perdu à retrouver une information cruciale. Ayez en un seul endroit ce qu'il faut à votre équipe pour avancer.",
  "usecase.org.s1.c3.title": "Déléguez, Supervisez, en 2 clics",
  "usecase.org.s1.c3.desc": "Assignez sans friction.",
  "usecase.org.s2.title": "Chaque collaborateur valorisé.",
  "usecase.org.s2.c1.title": "Une prise en main intuitive.",
  "usecase.org.s2.c1.desc":
    "Avec son interface ergonomique, il n'a jamais été aussi rapide de mettre en place une organisation solide.",
  "usecase.org.s2.c2.title": "Une considération individuelle",
  "usecase.org.s2.c2.desc":
    "Nous donnons à l'individu les outils pour servir le collectif. Nous réglons les problématiques de votre équipe à la racine.",
  "usecase.org.cta": "En savoir plus",
  "usecase.indiv.cta": "Travailler à plusieurs ?",

  "nav.features.indiv.label": "Individus",
  "nav.features.org.label": "Organisations",
  "nav.features.indiv.s1.desc": "Basé sur vos problématiques",
  "nav.features.indiv.s2.desc": "Tâches, agenda, notes et projets",
  "nav.features.indiv.s3.desc": "Suivez vos projets sur la durée",
  "nav.features.org.s1.desc": "Gérez vos projets ensemble",
  "nav.features.org.s2.desc": "Une considération individuelle",


  "fund.support": "Nous Soutenir",

  "footer.privacyFR": "Politique de confidentialité (FR)",
  "footer.privacyEN": "Privacy Policy (EN)",
  "footer.contact": "Nous contacter",
  "footer.nav.title": "Navigation",
  "footer.legal.title": "Légal",
  "footer.features.title": "Fonctionnalités",
  "footer.legalNotice": "Mentions légales",
  "footer.cgv": "Conditions générales de vente",
  "footer.manageCookies": "Gérer mes cookies",

  // ----- Cookie banner -----
  "cookieBanner.text":
    "Nous utilisons des données de navigation à des fins statistiques internes. Vous pouvez accepter ou refuser.",
  "cookieBanner.accept": "Accepter",
  "cookieBanner.reject": "Refuser",
  "cookieBanner.learnMore": "En savoir plus",

  // ----- Feature Discovery Modal -----
  "fd.next": "Suivant",
  "fd.done": "Terminer",

  "fd.tasks.simple.title": "Une tâche, tout simplement",
  "fd.tasks.simple.p1": "Une tâche est fondamentalement simple : un titre suffit. Vous pouvez la créer en 2 clics.",
  "fd.tasks.simple.p2": "Indiquez ce que vous avez à faire, puis revenez rapidement à l'action.",

  "fd.tasks.details.title": "La possibilité d'ajouter du détail",
  "fd.tasks.details.p1": "Si vous avez envie d'ajouter vos catégories, des sous-tâches, une description ou une récurrence tous les mardis ou jeudis, c'est aussi possible.",
  "fd.tasks.details.p2": "On vise l'essentiel, mais vous avez la liberté d'aller aussi loin que vos besoins.",

  "fd.tasks.notifications.title": "Les notifications au bon moment",
  "fd.tasks.notifications.p1": "Activez les notifications et soyez prévenus au bon moment.",
  "fd.tasks.notifications.p2": "Nous travaillons sur des systèmes pour vous rapporter l'information au moment où vous êtes disponibles pour la recevoir.",

  "fd.calendar.classic.title": "Un agenda classique",
  "fd.calendar.classic.p1": "Flots se comporte comme les agendas que vous avez déjà utilisés.",
  "fd.calendar.classic.p2": "Créez vos blocs de travail et vos rendez-vous en un clic, puis liez-le à Google Agenda facilement.",

  "fd.calendar.workingHours.title": "Configurez des horaires de travail",
  "fd.calendar.workingHours.p1": "Indiquez vos périodes de travail, pour que l'application puisse s'y adapter.",

  "fd.calendar.planDay.title": "Configurez votre journée en 5 minutes",
  "fd.calendar.planDay.p1": "Triez simplement vos tâches et placez-les dans votre agenda pour une journée bien planifiée.",

  "fd.notes.capture.title": "Notez tout, en 2 clics",
  "fd.notes.capture.p1": "Vos notes restent bien organisées. Écrivez, catégorisez, formatez avec la barre d'outils ou directement en Markdown.",
  "fd.notes.capture.p2": "Vous capturez une information vite, puis vous revenez travailler sans friction.",

  "fd.notes.suggestions.title": "Des notes aux tâches : la suggestion automatique",
  "fd.notes.suggestions.p1": "Extrayez automatiquement vos tâches depuis vos notes de réunion, comptes rendus, emails ou brouillons.",
  "fd.notes.suggestions.p2": "Elles sont ensuite directement référencées dans Flots pour ne pas perdre le suivi.",

  "fd.projects.focus.title": "La focalisation sur un sujet",
  "fd.projects.focus.p1": "Ayez des espaces isolés qui répertorient toute votre organisation pour un sujet précis.",
  "fd.projects.focus.p2": "Les projets permettent de ranger correctement vos tâches, vos notes, de suivre les étapes ou de partager avec vos collaborateurs.",

  "fd.projects.pins.title": "Les éléments épinglés",
  "fd.projects.pins.p1": "Mettez en première page les éléments cœur de vos projets, ce à quoi vous revenez à chaque fois lorsque vous travaillez sur ce sujet.",

  "fd.projects.milestones.title": "Les étapes",
  "fd.projects.milestones.p1": "Suivez là où vous en êtes.",
  "fd.projects.milestones.p2": "Voyez les étapes clés, le chemin critique de là où vous devez aller.",

  "fd.projects.collaboration.title": "Collaborez !",
  "fd.projects.collaboration.p1": "Mettez en commun l'organisation de vos projets, assignez des tâches, partagez vos notes.",
  "fd.projects.collaboration.p2": "Avancez ensemble clairement, le tout lié à votre organisation personnelle.",

  // ----- Exit intent popup -----
  "exit.title": "Vous partez déjà ?",
  "exit.description":
    "Avant de fermer l'onglet, prenez 5 minutes : c'est tout ce qu'il faut pour poser votre organisation dans Flots.",
  "exit.perk1": "2 mois offerts, sans carte bancaire",
  "exit.perk2": "Tâches, agenda, notes et projets au même endroit",
  "exit.perk3": "5 minutes suffisent pour prendre l'application en main",
  "exit.cta": "Testez Flots gratuitement",
  "exit.stay": "Je continue ma visite",

  // ----- Ressources -----
  "nav.ressources": "Ressources",
  "footer.ressources": "Ressources",
  "ressources.landing.title": "Ressources",
  "ressources.landing.description": "Guides pratiques, méthodes de productivité et actualités de l'application.",
  "ressources.recent.title": "Dernières ressources",
  "ressources.readingTime": "{minutes} min de lecture",
  "ressources.cta.default": "Essayer dans Flots",
  "ressources.rappel.label": "Rappel",
  "ressources.publishedOn": "Publié le {date}",
  "ressources.backToCategory": "Retour",
  "ressources.backToList": "Toutes les ressources",
  "ressources.related.title": "Articles similaires",
  "ressources.faq.title": "Questions fréquentes",
  "ressources.tags.all": "Tous les sujets",
  "ressources.empty.title": "Aucun article dans cette catégorie",
  "ressources.category.guides.label": "Guides",
  "ressources.category.guides.desc": "Prise en main de Flots, tutoriels pas à pas et vidéos démo.",
  "ressources.category.productivite.label": "Productivité",
  "ressources.category.productivite.desc": "Méthodes d'organisation et bonnes pratiques en solo ou en équipe.",
  "ressources.category.actualites.label": "Actualités",
  "ressources.category.actualites.desc": "Mises à jour de l'application, annonces et actualités de l'équipe.",
  "ressources.category.temoignages.label": "Témoignages",
  "ressources.category.temoignages.desc": "Retours d'expérience d'équipes et d'indépendants qui utilisent Flots.",
  "ressources.new.label": "Nouveau",
  "ressources.filter.allFormats": "Tous",
  "ressources.filter.noResults": "Aucun article pour ces filtres.",
  "ressources.format.tutoriel": "Tutoriel",
  "ressources.format.decouverte": "Découverte",
  "ressources.format.bonnesPratiques": "Bonnes pratiques",
  "ressources.format.actualite": "Actualité",
  "ressources.format.casPratique": "Cas pratique",

  // ----- Ressources: intro (/resources) -----
  "resources.hero.title": "Ressources",
  "resources.hero.lead":
    "Des guides pour prendre Flots en main, des méthodes pour vous organiser, et les nouveautés de l'application.",
  "resources.hero.guide.title": "Bien démarrer avec Flots",
  "resources.hero.guide.desc": "Le guide pas à pas, de votre première tâche à votre équipe.",
  "resources.hero.browse": "Parcourir par catégorie",
  "resources.hero.replay": "Rejouer l'animation des catégories",
  "resources.hero.count": "{count, plural, =0 {Bientôt} one {# article} other {# articles}}",
  "resources.hero.animation":
    "Les quatre catégories des ressources : guides, productivité, actualités et témoignages",

  // ----- Guide de démarrage (/guide) -----
  "guide.title": "Bien démarrer avec Flots",
  "guide.lead":
    "Sept étapes pour installer votre organisation, de votre première tâche à votre équipe. Pour chacune : la marche à suivre et une démonstration.",
  "guide.cta.signup": "Créer mon compte",
  "guide.toc.label": "Sommaire du guide",
  "guide.toc.title": "Premiers pas",
  "guide.toc.features": "Toutes les fonctionnalités",
  "guide.toc.resources": "Toutes les ressources",
  "guide.howto": "Marche à suivre",
  "guide.readMore": "Pour aller plus loin",
  "guide.tip": "Astuce",
  "guide.step.of": "Étape {n} sur {total}",

  "guide.step.premiere-tache.title": "Créez votre compte et votre première tâche",
  "guide.step.premiere-tache.lead":
    "Flots fonctionne sur le web, sur iPhone et sur Android. Une tâche démarre avec un simple titre : vous notez, puis vous repartez travailler.",
  "guide.step.premiere-tache.how.1":
    "Ouvrez Flots sur <b>dashboard.flots.app</b> ou installez l'application mobile, puis créez votre compte.",
  "guide.step.premiere-tache.how.2": "Ajoutez une tâche : un titre suffit, deux clics et c'est noté.",
  "guide.step.premiere-tache.how.3":
    "Ouvrez-la seulement si besoin, pour lui donner une catégorie, des sous-tâches ou une description.",
  "guide.step.premiere-tache.how.4": "Cochez-la une fois faite.",
  "guide.step.premiere-tache.tip":
    "Une tâche revient chaque semaine ? Donnez-lui une récurrence : elle revient toute seule au bon moment.",

  "guide.step.agenda.title": "Reliez votre agenda",
  "guide.step.agenda.lead":
    "Vos rendez-vous existants arrivent dans Flots, à côté de vos tâches. Rien à recopier, un seul agenda à tenir.",
  "guide.step.agenda.how.1": "Ouvrez <b>Paramètres</b>, section <b>Agenda</b>, onglet <b>Connexions</b>.",
  "guide.step.agenda.how.2": "Connectez votre compte Google Agenda, puis choisissez les agendas à synchroniser.",
  "guide.step.agenda.how.3":
    "Un emploi du temps publié en .ics ? Collez son adresse dans le bloc <b>Lien de calendrier ICS</b>.",
  "guide.step.agenda.how.4":
    "Donnez une couleur à chaque agenda : vous voyez d'un coup d'œil ce qui vient de l'extérieur.",

  "guide.step.journee.title": "Planifiez votre journée",
  "guide.step.journee.lead":
    "Vos tâches et votre agenda sur le même écran : en quelques minutes, vous savez par quoi commencer et ce que la journée peut contenir.",
  "guide.step.journee.how.1": "Indiquez vos horaires de travail, une fois pour toutes.",
  "guide.step.journee.how.2":
    "Ouvrez la vue <b>Planning</b> : les tâches du jour sont calées sur leur créneau, celles sans date attendent sur le côté.",
  "guide.step.journee.how.3": "Glissez une tâche sur un créneau libre.",
  "guide.step.journee.how.4": "Passez en vue semaine pour répartir la charge d'un jour à l'autre.",
  "guide.step.journee.tip":
    "Cap, l'assistant de Flots, vous aide à trier ce qu'il y a à faire et à poser vos tâches sur vos créneaux.",

  "guide.step.notes.title": "Transformez vos notes en tâches",
  "guide.step.notes.lead":
    "Prenez vos notes comme d'habitude. Flots repère les actions qu'elles contiennent et les fait remonter en tête de la note, prêtes à être organisées.",
  "guide.step.notes.how.1": "Créez une note en deux clics et écrivez, pendant la réunion ou juste après.",
  "guide.step.notes.how.2": "Mettez-la en forme avec la barre d'outils, ou directement en Markdown.",
  "guide.step.notes.how.3": "Retrouvez en tête de la note les tâches que Flots y a repérées.",
  "guide.step.notes.how.4": "Rangez la note dans une catégorie ou un projet pour la retrouver sans chercher.",
  "guide.step.notes.tip":
    "Les mains prises ? Sur mobile, enregistrez une note vocale depuis Docs : elle se range comme une note.",

  "guide.step.projet.title": "Rassemblez un sujet dans un projet",
  "guide.step.projet.lead":
    "Un client, un dossier, un chantier qui dure : un projet réunit ses tâches, ses notes, ses documents et ses étapes au même endroit.",
  "guide.step.projet.how.1": "Créez un projet pour le sujet qui vous occupe le plus en ce moment.",
  "guide.step.projet.how.2": "Ajoutez-y vos tâches et vos notes, et importez les documents qui vont avec.",
  "guide.step.projet.how.3": "Posez les étapes du projet : vous voyez ce qui est fait et ce qui vient ensuite.",
  "guide.step.projet.how.4":
    "Épinglez le brief ou la note de référence : ils vous attendent à chaque ouverture du projet.",

  "guide.step.equipe.title": "Invitez votre équipe",
  "guide.step.equipe.lead":
    "Un projet se partage avec les personnes qui y travaillent. Chacun voit ce qui lui revient, sans réunion de suivi.",
  "guide.step.equipe.how.1": "Ouvrez le projet à partager, puis la liste de ses membres.",
  "guide.step.equipe.how.2": "Ajoutez chaque personne avec l'email de son compte Flots.",
  "guide.step.equipe.how.3":
    "Choisissez son rôle : <b>Éditeur</b> pour lire et écrire, <b>Lecteur</b> pour consulter seulement.",
  "guide.step.equipe.how.4":
    "Assignez-lui une tâche : elle apparaît dans sa liste, et l'avancement se met à jour dès qu'elle la coche.",
  "guide.step.equipe.tip":
    "Les notes d'un projet partagé s'écrivent à plusieurs, en direct : un bandeau montre qui est présent sur la note.",

  "guide.step.import.title": "Venez avec vos données Notion ou Todoist",
  "guide.step.import.lead":
    "Inutile de repartir de zéro : Flots se connecte à votre compte et reprend vos projets, vos tâches et vos notes, sans export de fichier.",
  "guide.step.import.how.1": "Dans les paramètres de Flots, choisissez d'importer depuis Notion ou Todoist.",
  "guide.step.import.how.2": "Autorisez l'accès à votre compte, comme pour relier un compte Google à un autre outil.",
  "guide.step.import.how.3": "Flots recrée vos projets, vos tâches et vos notes. Rien à trier derrière.",
  "guide.step.import.tip":
    "Une base Notion avec une colonne de statut devient un projet et ses tâches ; un projet Todoist devient un projet Flots.",
  "guide.step.import.cta": "Lancer l'import",

  "guide.features.title": "Toutes les fonctionnalités",
  "guide.features.lead": "Chaque outil a son guide détaillé dans les ressources.",
  "guide.features.group.organize": "S'organiser",
  "guide.features.group.write": "Écrire et ranger",
  "guide.features.group.team": "Travailler à plusieurs",
  "guide.features.group.connect": "Relier vos outils",
  "guide.feature.tasks.title": "Tâches",
  "guide.feature.tasks.desc": "Un titre suffit. Catégories, sous-tâches, récurrence et rappels quand vous en avez besoin.",
  "guide.feature.agenda.title": "Agenda et vue Planning",
  "guide.feature.agenda.desc": "Vos rendez-vous et vos tâches sur le même écran, à la journée ou à la semaine.",
  "guide.feature.cap.title": "Cap, l'assistant",
  "guide.feature.cap.desc": "Il vous aide à planifier vos journées et garde l'essentiel en vue.",
  "guide.feature.notes.title": "Notes",
  "guide.feature.notes.desc": "Markdown, catégories, sommaire automatique et tâches repérées dans le texte.",
  "guide.feature.documents.title": "Documents",
  "guide.feature.documents.desc": "PDF et images rangés en dossiers, reliés à vos notes et à vos projets.",
  "guide.feature.whiteboards.title": "Tableaux blancs",
  "guide.feature.whiteboards.desc": "Formes, flèches et texte pour poser un schéma, rattaché à un projet.",
  "guide.feature.projects.title": "Projets",
  "guide.feature.projects.desc": "Un espace par sujet, avec ses étapes, ses éléments épinglés et ses membres.",
  "guide.feature.live.title": "Édition en direct",
  "guide.feature.live.desc": "Notes et tableaux blancs d'un projet partagé s'écrivent à plusieurs, en même temps.",
  "guide.feature.workload.title": "Charge de l'équipe",
  "guide.feature.workload.desc": "La vue Planning en semaine montre qui est chargé et qui a de la marge.",
  "guide.feature.calendars.title": "Google Agenda et .ics",
  "guide.feature.calendars.desc": "Vos agendas existants dans Flots, une couleur pour chacun.",
  "guide.feature.import.title": "Import Notion et Todoist",
  "guide.feature.import.desc": "Projets, tâches et notes repris depuis votre compte, sans fichier à exporter.",
  "guide.feature.mcp.title": "Assistants IA (MCP)",
  "guide.feature.mcp.desc": "Branchez Claude ou un autre assistant compatible sur Flots, avec les permissions que vous choisissez.",

  "guide.help.title": "Une question ?",
  "guide.help.desc": "Une équipe française vous répond sous 24 h.",
  "guide.help.contact": "Nous écrire",

  // ----- Business card (/card) -----
  "footer.card": "Carte de visite",
  "card.tagline": "Votre organisation simplifiée",

  "card.point1.title": "Tout au même endroit",
  "card.point2.title": "Un secrétaire de poche",
  "card.point3.title": "Français, hébergé en Europe",

  "card.qr.title": "Scannez pour installer Flots",

  "card.platform.web.label": "Web",
  "card.platform.web.store": "dashboard.flots.app",
  "card.platform.web.devices": "Navigateur, tablette et iPad",
  "card.platform.android.label": "Android",
  "card.platform.android.store": "Google Play",
  "card.platform.android.devices": "Téléphones et tablettes Android",
  "card.platform.ios.label": "iOS",
  "card.platform.ios.store": "App Store",
  "card.platform.ios.devices": "iPhone et iPad",

  "card.catchphrase": "Arrêtez de jongler entre dix applications.",
  "card.catchphraseSub":
    "Concentrez-vous sur votre métier, plus sur votre organisation.",

  "a11y.card.previous": "Plateforme précédente",
  "a11y.card.next": "Plateforme suivante",
  "a11y.card.qr": "QR code d'installation de Flots pour {platform}",

  // ----- Accessibility pass (skip link, landmarks, forms, filters) -----
  "a11y.skipToContent": "Aller au contenu principal",
  "a11y.mainNav": "Navigation principale",
  "a11y.video.pauseLoop": "Mettre l'animation en pause",
  "a11y.video.playLoop": "Lire l'animation",
  "contact.label.subject": "Sujet",
  "contact.label.message": "Message",
  "contact.allRequired": "Tous les champs sont obligatoires.",
  "contact.error.name": "Indiquez votre nom.",
  "contact.error.email": "Indiquez une adresse e-mail valide, par exemple nom@exemple.fr.",
  "contact.error.subject": "Choisissez un sujet.",
  "contact.error.content": "Écrivez votre message.",
  "contact.error.send": "Le message n'a pas pu être envoyé. Réessayez dans un instant.",
  "ressources.tags.label": "Filtrer par sujet",
  "ressources.results": "{count, plural, one {# article} other {# articles}}",
  "ressources.showMore": "Voir plus d'articles ({count, plural, one {# restant} other {# restants}})",

  // ----- Home v4: promise, problem, product tour -----
  "hero.promise": "Votre organisation tourne sans que vous ayez à <em>y penser</em>.",
  "hero.video.play": "Voir Flots en action",
  "a11y.video.progress": "Progression de la vidéo",

  "trust.europe": "Hébergé en Europe",
  "trust.devices": "Web, iOS et Android",
  "trust.import": "Import Notion et Todoist",
  "trust.support": "Une équipe française qui répond sous 24 h",

  "problem.eyebrow": "Le problème",
  "problem.title": "Aujourd'hui, s'organiser est un second métier",
  "problem.heavy.title": "Soit un outil qu'il faut construire",
  "problem.heavy.desc": "Les grosses plateformes demandent quelqu'un pour monter les vues et les faire tourner, et ce poste n'existe pas chez vous.",
  "problem.scattered.title": "Soit cinq outils à relier de tête",
  "problem.scattered.desc": "Tâches, notes, agenda, fichiers : chacun dans son coin, et c'est vous qui faites le lien, tous les jours.",
  "problem.flots.title": "Flots : ni l'un, ni l'autre",
  "problem.flots.desc": "Tout est au même endroit, déjà rangé : vous ouvrez, et vous travaillez.",

  "story.eyebrow": "Comment ça marche",
  "story.title": "Tout au même endroit, et tout de suite utilisable.",
  "story.nav": "Étapes de la présentation",
  "story.scrollHint": "Faites défiler",
  "story.part.problem": "Le problème",
  "story.part.build": "Rien à construire",
  "story.part.action": "De la réunion à l'action",
  "story.part.team": "L'équipe",
  "story.part.trust": "Vos données",
  "story.group.build": "Rien à construire, rien à apprendre",
  "story.group.action": "De la réunion à l'action",
  "story.group.team": "L'outil sert chacun, l'équipe avance",
  "story.group.trust": "Vos données restent les vôtres",
  "story.tasks.title": "Notez ce qu'il y a à faire. C'est tout.",
  "story.tasks.desc":
    "Ni modèle à choisir, ni vue à monter : des tâches, un agenda, des notes, et vous travaillez en cinq minutes.",
  "story.agenda.title": "Chaque tâche trouve son créneau.",
  "story.agenda.desc":
    "Glissez-la sur une heure libre de votre agenda : le temps de la faire est réservé, à côté de vos rendez-vous.",
  "story.devices.title": "Noté sur le téléphone, prêt sur l'ordinateur.",
  "story.devices.desc":
    "Une idée entre deux rendez-vous se note en deux secondes, et au bureau elle est déjà dans votre liste.",
  "story.notes.title": "Vos notes de réunion deviennent des tâches.",
  "story.notes.desc":
    "Un bouton après la réunion : Cap, votre assistant, relève qui fait quoi et pour quand, et vous validez.",
  "story.planday.title": "Votre journée, prête chaque matin.",
  "story.planday.desc":
    "À l'heure que vous choisissez, Cap rassemble le prévu, les restes d'hier et ce qui n'a pas de date : vous n'avez plus qu'à classer.",
  "story.project.title": "Suivez vos projets, sans rien paramétrer.",
  "story.project.desc":
    "Étapes, tâches et documents au même endroit. L'avancement se calcule tout seul.",
  "story.delegate.title": "Qui fait quoi, sans réunion de suivi.",
  "story.delegate.desc":
    "Glissez une tâche vers un collègue : il est prévenu, et chacun voit ce qui lui revient.",
  "story.live.title": "Un seul brief, écrit à plusieurs.",
  "story.live.desc":
    "Notes et tableaux blancs partagés en direct : chacun écrit en même temps, fini les « v3_finale » envoyées par email.",
  "story.privacy.title": "Chacun décide de ce qu'il partage.",
  "story.privacy.desc":
    "Un rendez-vous perso reste privé, une idée pour le client passe à l'équipe d'un geste : personne ne se sent surveillé.",
  "story.europe.title": "Hébergées en Europe. Jamais revendues.",
  "story.europe.desc":
    "Vos données restent chez des hébergeurs européens et n'entraînent aucun modèle global. Une question ? Une équipe vous répond sous 24 h.",

  "nav.story.tasks.title": "Tâches et agenda",
  "nav.story.tasks.desc": "Rien à construire, rien à apprendre",
  "nav.story.notes.title": "Notes de réunion",
  "nav.story.notes.desc": "Cap propose, vous validez",
  "nav.story.planday.title": "Le rituel du matin",
  "nav.story.planday.desc": "Votre journée prête à l'heure choisie",
  "nav.story.project.title": "Projets",
  "nav.story.project.desc": "Suivis sans paramétrage",
  "nav.story.delegate.title": "Délégation",
  "nav.story.delegate.desc": "Qui fait quoi, sans réunion",
  "nav.story.privacy.title": "Confidentialité",
  "nav.story.privacy.desc": "Chacun décide de ce qu'il partage",
  "nav.story.live.title": "À plusieurs, en direct",
  "nav.story.live.desc": "Notes et tableaux blancs partagés",

  "profile.title": "Qui êtes-vous ?",
  "profile.lead": "Seul ou en équipe, Flots s'adapte à votre façon de travailler.",
  "profile.tablist": "Votre profil",
  "profile.replay": "Rejouer l'animation : {title}",
  "profile.individual.tab": "Un individu",
  "profile.individual.who": "Indépendant, étudiant, dirigeant",
  "profile.individual.lead": "Une organisation qui suit votre journée, pas l'inverse.",
  "profile.individual.cta": "Commencer gratuitement",
  "profile.organization.tab": "Une organisation",
  "profile.organization.who": "Équipe, PME, association",
  "profile.organization.lead": "L'outil sert chaque personne, et c'est l'équipe qui avance.",
  "profile.organization.cta": "Essayer avec mon équipe",
  "profile.organization.demo": "Réserver une démo",
  "profile.organization.gains.title": "Votre équipe démarre le jour même",
  "profile.organization.gains.lead":
    "Ni chantier de mise en place, ni formation, ni ressaisie.",
  "profile.organization.gains.fiveMinutes.title": "Pris en main en cinq minutes",
  "profile.organization.gains.fiveMinutes.desc":
    "Des tâches, un agenda, des notes : chacun sait déjà s'en servir.",
  "profile.organization.gains.import.title": "Rien à recopier",
  "profile.organization.gains.import.desc":
    "Vos tâches Notion ou Todoist arrivent en un clic, rangées dans leurs projets.",
  "profile.organization.gains.newcomer.title": "Un nouvel arrivant ? Un email suffit.",
  "profile.organization.gains.newcomer.desc":
    "Ajoutez-le au projet : tâches, notes et documents l'y attendent déjà.",
  "profile.organization.gains.wanted.title": "Un outil qu'on a envie d'ouvrir",
  "profile.organization.gains.wanted.desc":
    "Chacun y trouve son espace et sa journée prête : on l'adopte au lieu de le subir.",

  "trust.lead":
    "La souveraineté des données est au cœur de notre démarche : ce que vous mettez dans Flots vous appartient.",
  "trust.personal.title": "Votre espace personnel",
  "trust.personal.desc": "Vos notes, vos tâches, vos échanges avec Cap : privés, même pour votre employeur.",
  "trust.company.title": "L'espace de l'entreprise",
  "trust.company.desc": "Le devis, les photos de la boutique : rangés dans ses projets, l'équipe les retrouve. Par défaut, rien d'autre n'est visible.",
  "trust.hosted": "Hébergées en Europe",
  "trust.neverSold": "Jamais revendues",
  "trust.noTraining": "Aucun modèle global entraîné dessus",

  "finalCta.morningAlt":
    "Le matin dans Flots : sous « Par quoi commencer », la carte « Envoyer le devis v2 » se pose en tête de votre journée.",

};

export default fr;
